import { render, staticRenderFns } from "./PastizalInundableParaguai.vue?vue&type=template&id=e6174be0&lang=pug"
import script from "./PastizalInundableParaguai.vue?vue&type=script&lang=js"
export * from "./PastizalInundableParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports